Ext.define('SA.lq.view.ViewController', {
    constructor({model, searchController, gridColumnMenuFactory, gridSizer, exportActivityFactory, locationCellMenuItemsFactory, cmps}) {
        this.model = model;
        this.searchController = searchController;
        this.gridColumnMenuFactory = gridColumnMenuFactory;
        this.gridSizer = gridSizer;
        this.exportActivityFactory = exportActivityFactory;
        this.locationCellMenuItemsFactory = locationCellMenuItemsFactory;
        this.cmps = cmps;
    },

    onActive() {
        SA.SidebarState.create()
            .enableTabs(['locations', 'data'])
            .selectTab(SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'data')
            .setModel(this.model)
            .apply();

        SA.Sidebar.setUseAttributeHandler(attributeId => this.onAddConditionIntent(attributeId));
        SA.Sidebar.setUseLocationHandler(location => this.onSelectLocationIntent(SA.data.LocationsCache.toLocationSeries(location)));

        SA.ProjectViewToolbar.setToolbar(this.cmps.toolbar);
        SA.ProjectView.show(this.cmps.projectView);

        this.refreshContent();
        this.gridSizer.resize();
    },

    onAddConditionIntent(attributeId) {
        SA.data.RecentAttributes.add(attributeId);

        if (this.model.getState().hasMaxConditions()) {
            this.model.addAttributeToProject(attributeId);
            this.refreshContent();
            return;
        }

        this.cmps.conditionList.addDefaultConditionForAttributeId(attributeId);
    },

    onConditionListCmpChange() {
        this.model.setConditionList(this.cmps.conditionList.mapToModel());
        this.cmps.searchBtn.enable();
        this.refreshContent();
    },

    onGeoUnitsComboChange(geoUnitId) {
        this.model.selectGeoUnit(geoUnitId);
        this.refreshContent();
        this.refreshSearch();
    },

    onGridColumnClick({el, dataIndex, sort}) {
        var items = this.gridColumnMenuFactory.getItems({dataIndex, sort});

        this.cmps.resultsGrid.showMenu({el, items});
    },

    onGridColumnMenuSortItemClick(sort) {
        this.model.setSort(sort);

        this.performSearch();
    },

    onGridLocationCellClick({el, row}) {
        var {locationInfo} = row,
            menuItems = this.locationCellMenuItemsFactory.getItems({
            locationInfo,

            handlers: {
                addToProject: () => this.onLocationMenuAddToProjectClick(locationInfo),
                addToFavorites: () => this.onLocationMenuAddToFavoritesClick(locationInfo),
                removeFromFavorites: () => SA.data.FavoriteLocations.remove(locationInfo.locationSeries),
                addAlias: () => this.openAliasWindow(locationInfo),
                editAlias: () => this.openAliasWindow(locationInfo)
            }
        });

        this.cmps.resultsGrid.showMenu({el, items: menuItems});
    },

    async onLocationMenuAddToFavoritesClick({locationSeries}) {
        await SA.data.LocationsCache.getPromise([locationSeries]);

        SA.data.FavoriteLocations.add(locationSeries);
    },

    async onLocationMenuAddToProjectClick({locationSeries}) {
        var [location] = await SA.data.LocationsCache.getPromise([locationSeries]);

        this.model.addLocationToProject(location);
        this.cmps.locationsCombo.setState(this.model.getState());
    },

    onLocationAliasChange(aliasChange) {
        this.cmps.locationsCombo.setState(this.model.getState());
        this.searchController.applyLocationAliasChange(aliasChange);
    },

    onSearchBtnClick() {
        if (!this.resultsPanelVisible()) {
            this.cmps.resultsPanel.show();
            this.gridSizer.resize();
        }

        this.cmps.searchBtn.disableWithOptions({clearOverCls: true, retainPointerCursor: true});
        this.performSearch();
    },

    onSelectLocationIntent(locationStringId) {
        this.model.selectLocation(locationStringId);
        this.refreshContent();
        this.refreshSearch();
    },

    onToolbarExportBtnClick() {
        this.cmps.toolbarExportBtn.setActive();

        this.exportActivityFactory.createActivity({
            state: this.model.getState(),

            onDone: () => {
                this.cmps.toolbarExportBtn.setInactive();
                this.cmps.toolbarExportBtn.on('click', this.onToolbarExportBtnClick, this, {single: true});
            }
        });
    },

    openAliasWindow({locationSeries, name, alias}) {
        var nameEncoded = Ext.String.htmlEncode(name),
            titleHtml = alias === null ? `Add alias for ${nameEncoded}` : `Edit alias for ${nameEncoded}`,
            popup = Ext.widget({xtype: 'location-alias-window-2', titleHtml}),
            field = popup.down('#field');

        field.setValue(alias);
        field.focus();

        popup.down('#saveBtn').on('click', () => {
            popup.destroy();

            SA.data.LocationAliases.set(locationSeries, field.getValue().trim());
        });
    },

    performSearch() {
        this.searchController.onSearchIntent(this.model.getState());
    },

    refreshContent() {
        var state = this.model.getState();

        this.cmps.locationsCombo.setState(state);
        this.cmps.geoUnitsCombo.setState(state);
        this.cmps.attributeSelector.setState(state);
        this.cmps.conditionList.setState(state.getConditionList());
    },

    refreshSearch() {
        if (!this.resultsPanelVisible()) {
            return;
        }

        this.performSearch();
    },

    resultsPanelVisible() {
        return this.cmps.resultsPanel.isVisible();
    }
});
